import fetchHTTP from '../Utils/fetchHTTP';
import { getLocalStorage } from '../Utils/useGetMerchant';
import ApiResponses from './dummy_api_responses.json';

// --- deprecated
function buildPaymentsQuery(
  searchBy,
  startDate,
  endDate,
  channel,
  paymentType
) {
  let searchQuery = searchBy ? `&search_term=${searchBy}` : '';
  if (startDate) {
    searchQuery += `&start_date_range=${startDate}`;
  }
  if (endDate) {
    searchQuery += `&end_date_range=${endDate}`;
  }
  if (channel) {
    searchQuery += `&channel=${channel}`;
  }
  if (paymentType) {
    searchQuery += `&payment_status=${paymentType}`;
  }
  return searchQuery;
}

const getPayments = (
  paymentType,
  searchBy,
  page = 1,
  limit = 20,
  startDate,
  endDate,
  channel
) => {
  let searchQuery = buildPaymentsQuery(
    searchBy,
    startDate,
    endDate,
    channel,
    paymentType
  );

  const merchantSelected =
    JSON.parse(getLocalStorage('merchantSelected')) ?? {};
  let merchantQuery = '';
  if (Object.keys(merchantSelected).length > 0) {
    merchantQuery = `&merchant_id=${merchantSelected.merchant_id}`;
  }

  return fetchHTTP(
    `/api/protected/merchant_sales/payments_movements_aggregates?${searchQuery}&order_by=created_at&page=${page}&limit=${limit}${merchantQuery}`,
    {
      method: 'GET',
    }
  );
};

const exportPayments = (paymentType, searchBy, startDate, endDate, channel) => {
  let searchQuery = buildPaymentsQuery(
    searchBy,
    startDate,
    endDate,
    channel,
    paymentType
  );

  const merchantSelected =
    JSON.parse(getLocalStorage('merchantSelected')) ?? {};
  let merchantQuery = '';
  if (Object.keys(merchantSelected).length > 0) {
    merchantQuery = `&merchant_id=${merchantSelected.merchant_id}`;
  }

  return fetchHTTP(
    `/api/protected/merchant_sales/payments_movements_aggregates/export?${searchQuery}&order_by=payment_created_at_desc${merchantQuery}`,
    {
      method: 'GET',
      responseType: 'blob',
    }
  ).then(res => {
    // noinspection JSCheckFunctionSignatures
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'payments.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  });
};

const requestPaymentIdValidation = (paymentId, merchantId) => {
  return fetchHTTP(
    `/api/protected/orders/validate_payment?payment_id=${paymentId}&merchant_id=${merchantId}`,
    {
      method: 'GET',
    }
  );
};

// --- deprecated

const createMerchantUser = user => {
  return fetchHTTP('/api/protected/merchant_users', {
    method: 'POST',
    data: user,
  });
};

const requestRefund = refund => {
  return fetchHTTP('/api/protected/merchant_sales/refunds', {
    method: 'POST',
    data: refund,
  });
};

const createStore = store => {
  return fetchHTTP('/api/protected/stores', {
    method: 'POST',
    data: store,
  });
};

const updateStore = (store, id) => {
  return fetchHTTP(`/api/protected/stores/${id}`, {
    method: 'PUT',
    data: store,
  });
};

const requestOrderRefund = refund => {
  return fetchHTTP('/api/protected/refunds', {
    method: 'POST',
    data: refund,
  });
};

const requestUsersValidation = users => {
  return fetchHTTP('/api/protected/merchant_users/bulk/validate', {
    method: 'POST',
    data: users,
  });
};

const requestImportUsersCreation = users => {
  return fetchHTTP('/api/protected/merchant_users/bulk', {
    method: 'POST',
    data: users,
  });
};

const bulkValidateStore = data => {
  return fetchHTTP('/api/protected/stores/bulk/validate', {
    method: 'POST',
    data,
  });
};

const createBulkStore = data => {
  return fetchHTTP('/api/protected/stores/bulk', {
    method: 'POST',
    data,
  });
};

const validateOffering = payload => {
  return fetchHTTP('/api/v1/protected/validate_offering', {
    method: 'POST',
    data: payload,
  });
};

const saveLogbehavior = ({ userId, log_behavior_data }) => {
  return fetchHTTP('/api/protected/log', {
    method: 'POST',
    data: {
      user_id: userId,
      log_behavior: log_behavior_data,
    },
  });
};

const orderVerdict = (orderId, data) => {
  return fetchHTTP(`/api/protected/orders/${orderId}`, {
    method: 'PATCH',
    data,
  });
};

const updateMerchantUser = (userId, user) => {
  return fetchHTTP(`/api/protected/merchant_users/${userId}`, {
    method: 'PUT',
    data: user,
  });
};

const getCampaigns = () => {
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/campaigns']);
  });
};

const getCampaignById = campaignId => {
  console.log(campaignId);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP(`/api/protected/campaigns/${campaignId}`, {
    method: 'GET'
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/campaigns/<campaign_id>']);
  });
};

const getCampaignDirectoryDownloadZip = directoryId => {
  console.log(directoryId);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP(`/api/protected/campaigns/download/zip/${directoryId}`, {
    method: 'GET'
  });*/
  return new Promise(resolve => {
    resolve(
      ApiResponses['/api/protected/campaigns/download/zip/<directory_id>']
    );
  });
};

const getAssetDownload = assetId => {
  console.log(assetId);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP(`/api/protected/campaigns/download/asset/${assetId}`, {
    method: 'GET'
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/campaigns/download/asset/<asset_id>']);
  });
};

const deleteMerchantImage = merchantImage => {
  console.log(merchantImage);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP('/api/protected/merchant_image', {
    method: 'DELETE',
    data: merchantImage.id,
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/merchant_image/<action>']);
  });
};

const getMerchantImages = merchantId => {
  console.log(merchantId);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP(`/api/protected/merchant_image/${merchantId}`, {
    method: 'GET'
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/merchant_image/<merchant_id>']);
  });
};

const createMerchantImage = merchantImage => {
  console.log(merchantImage);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP('/api/protected/merchant_image', {
    method: 'POST',
    data: merchantImage,
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/merchant_image/<action>']);
  });
};

const updateMerchantImage = merchantImage => {
  console.log(merchantImage);
  /*
  Uncomment when endpoint is ready
  return fetchHTTP('/api/protected/merchant_image', {
    method: 'POST',
    data: merchantImage,
  });*/
  return new Promise(resolve => {
    resolve(ApiResponses['/api/protected/merchant_image/<action>']);
  });
};

export {
  bulkValidateStore,
  createBulkStore,
  createMerchantImage,
  createMerchantUser,
  createStore,
  deleteMerchantImage,
  exportPayments,
  getAssetDownload,
  getCampaignById,
  getCampaignDirectoryDownloadZip,
  getCampaigns,
  getMerchantImages,
  getPayments,
  orderVerdict,
  requestImportUsersCreation,
  requestOrderRefund,
  requestPaymentIdValidation,
  requestRefund,
  requestUsersValidation,
  saveLogbehavior,
  updateMerchantImage,
  updateMerchantUser,
  updateStore,
  validateOffering,
};
